export default __webpack_public_path__ + "guy-holding-div.2b3b9b.svg";